module.exports = __webpack_public_path__ + "static/images/share-group-bg.80b4707.png";